<template>
    <div class="new-provider-body-separator">
        <div class="new-provider-body-text-title">Informações da empresa</div>
        <div class="new-provider-body-input-line">
            <StandardInput
                class="new-provider-body-input"
                :title="'CNPJ'"
                :mask="'## ### ###/####-##'"
                :auto="true"
                :value="provider.head_office.cnpj"
                :action="setCnpj"
                :type="'text'"
            />
            <StandardInput
                class="new-provider-body-input"
                :title="'Razão Social'"
                :auto="true"
                :action="setSocial"
                :value="provider.head_office.social_reazon"
                :type="'text'"
            />
        </div>
        <div class="new-provider-body-input-line">
            <StandardInput
                class="new-provider-body-input"
                :title="'Nome Fantasia'"
                :auto="true"
                :value="provider.head_office.trading_name"
                :action="setFantasyName"
                :type="'text'"
            />
            <StandardInput
                class="new-provider-body-input"
                :title="'Email'"
                :auto="true"
                :action="setEmail"
                :value="provider.head_office.email"
                :type="'text'"
            />
        </div>
        <div class="new-provider-body-input-line">
            <StandardInput
                class="new-provider-body-input"
                :title="'Contato'"
                :auto="true"
                :value="provider.contact"
                :action="setContact"
                :type="'text'"
            />
            <StandardInput
                class="new-provider-body-input"
                :title="'Site'"
                :auto="true"
                :value="provider.site_url"
                :action="setSite"
                :type="'text'"
            />
        </div>
        <div class="new-provider-body-input-line">
            <StandardInput
                class="new-provider-body-input"
                :mask="'(##) #.####-####'"
                :title="'Telefone'"
                :auto="true"
                :value="provider.head_office.phone"
                :action="setPhone"
                :type="'text'"
            />

            <StandardInput
                class="new-provider-body-input-selected"
                :title="'Revenda'"
                :placeholder="
                    loadingResale ? 'Carregando...' : selectedResaleText || 'Selecione uma revenda'
                "
                :value="selectedResaleText"
                :list="resalesOptions"
                :action="setResale"
                :type="'select'"
                :disabled="loadingResale"
                :loading="loadingResale"
            />
        </div>
        <div class="new-provider-body-info-checks">
            <div>
                <div class="new-provider-body-title">Tipo de entrega</div>
                <div class="new-provider-body-info-checks-line">
                    <div
                        style="display: flex; align-items: center; cursor: pointer"
                        v-on:click="setDeliveryType(1)"
                    >
                        <span
                            v-if="provider.delivery_type_id == 1"
                            class="material-icons-outlined new-provider-body-info-check-icon"
                            >check_box</span
                        >
                        <span
                            v-else
                            class="material-icons-outlined new-provider-body-info-check-icon"
                            >check_box_outline_blank</span
                        >
                        <div class="new-provider-body-info-check-text">CIF</div>
                    </div>
                    <div
                        style="display: flex; align-items: center; cursor: pointer"
                        v-on:click="setDeliveryType(2)"
                    >
                        <span
                            v-if="provider.delivery_type_id == 2"
                            class="material-icons-outlined new-provider-body-info-check-icon"
                            >check_box</span
                        >
                        <span
                            v-else
                            class="material-icons-outlined new-provider-body-info-check-icon"
                            >check_box_outline_blank</span
                        >
                        <div class="new-provider-body-info-check-text">CIF/FOB</div>
                    </div>
                    <div
                        style="display: flex; align-items: center; cursor: pointer"
                        v-on:click="setDeliveryType(3)"
                    >
                        <span
                            v-if="provider.delivery_type_id == 3"
                            class="material-icons-outlined new-provider-body-info-check-icon"
                            >check_box</span
                        >
                        <span
                            v-else
                            class="material-icons-outlined new-provider-body-info-check-icon"
                            >check_box_outline_blank</span
                        >
                        <div class="new-provider-body-info-check-text">FOB</div>
                    </div>
                </div>
            </div>
            <div>
                <div class="new-provider-body-title">Fornecedor Plus?</div>
                <div class="new-provider-body-info-checks-line">
                    <div
                        style="display: flex; align-items: center; cursor: pointer"
                        v-on:click="setProviderPlus(true)"
                    >
                        <span
                            v-if="provider.is_plus"
                            class="material-icons-outlined new-provider-body-info-check-icon"
                            >check_box</span
                        >
                        <span
                            v-else
                            class="material-icons-outlined new-provider-body-info-check-icon"
                            >check_box_outline_blank</span
                        >
                        <div class="new-provider-body-info-check-text">Sim</div>
                    </div>
                    <div
                        style="display: flex; align-items: center; cursor: pointer"
                        v-on:click="setProviderPlus(false)"
                    >
                        <span
                            v-if="!provider.is_plus"
                            class="material-icons-outlined new-provider-body-info-check-icon"
                            >check_box</span
                        >
                        <span
                            v-else
                            class="material-icons-outlined new-provider-body-info-check-icon"
                            >check_box_outline_blank</span
                        >
                        <div class="new-provider-body-info-check-text">Não</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ProviderService from "@/services/v3/provider.service";
import CategoryService from "@/services/v3/category.service";
import StandardInput from "@/components/ui/inputs/StandardInputV2.vue";
import SelectCheckFiltered from "../../../components/ui/inputs/SelectCheckFiltered.vue";

export default {
    mixins: [loaderMixin],
    props: ["provider", "getCnpjInfo"],
    components: {
        ValidationProvider,
        ValidationObserver,
        StandardInput,
        SelectCheckFiltered,
    },
    data() {
        return {
            svc: new ProviderService(),
            cat_svc: new CategoryService(),
            categories: [],
            resales: [],
            request_types: [],
            sectors: [],
            loadingResale: false,
        };
    },
    watch: {
        provider: {
            immediate: true,
            handler(newVal) {
                if (newVal.revenda_id && this.resales.length > 0) {
                    return;
                }
                this.loadResales();
            },
        },
    },
    computed: {
        resalesOptions() {
            const options = this.resales.map((resale) => ({
                value: resale.id,
                text: resale.name || resale.trading_name || `Revenda ${resale.id}`,
                id: resale.id,
            }));

            if (!this.provider.revenda_id) {
                options.unshift({
                    value: null,
                    text: "Selecione uma revenda",
                    disabled: true,
                });
            }

            return options;
        },

        selectedResaleText() {
            if (!this.provider.revenda_id) return "";
            const resale = this.resales.find((r) => r.id === this.provider.revenda_id);
            if (resale) {
                return resale.name || resale.trading_name || `Revenda ${resale.id}`;
            }
            if (this.provider.resale) {
                return (
                    this.provider.resale.name ||
                    this.provider.resale.trading_name ||
                    `Revenda ${this.provider.revenda_id}`
                );
            }
            return `Revenda ${this.provider.revenda_id}`;
        },
    },
    methods: {
        setSocial(value) {
            this.provider.head_office.social_reazon = value;
            this.provider.social_reazon = value;
        },
        setEmail(value) {
            this.provider.manager.email = value;
            this.provider.head_office.email = value;
            this.provider.email = value;
        },
        setCnpj(value) {
            this.provider.head_office.cnpj = value;
            this.provider.cnpj = value;
            let cnpj = this.provider.head_office.cnpj.replace("/", "");
            cnpj = cnpj.replace("-", "");
            cnpj = cnpj.replace(" ", "");
            cnpj = cnpj.replace(" ", "");
            if (cnpj.length > 13) this.getCnpjInfo(cnpj);
        },
        setFantasyName(value) {
            this.provider.head_office.trading_name = value;
            this.provider.trading_name = value;
            this.provider.name = value;
        },
        setContact(value) {
            this.provider.contact = value;
        },
        setSite(value) {
            this.provider.site_url = value;
        },
        setPhone(value) {
            this.provider.phone = value;
            this.provider.manager.phone = value;
            this.provider.head_office.phone = value;
        },
        setResale(value) {
            this.provider.revenda_id = value ? Number(value) : null;
        },
        setDeliveryType(value) {
            this.provider.delivery_type_id = value;
            this.$forceUpdate();
        },
        setProviderPlus(value) {
            this.provider.is_plus = value;
            this.$forceUpdate();
        },

        async loadResales() {
            this.loadingResale = true;

            try {
                const response = await this.svc.getResales();
                this.resales = response.data?.data || [];
                if (
                    this.provider.revenda_id &&
                    !this.resales.some((r) => r.id === this.provider.revenda_id)
                ) {
                    if (this.provider.resale) {
                        this.resales.unshift(this.provider.resale);
                    } else {
                        this.resales.unshift({
                            id: this.provider.revenda_id,
                            name: `Revenda ${this.provider.revenda_id}`,
                        });
                    }
                }
            } catch (error) {
                console.error("Erro ao carregar revendas:", error);
            } finally {
                this.loadingResale = false;
            }
        },
    },
    mounted() {
        this.loadResales();
    },
};
</script>

<style lang="scss" scoped>
@import "./new-provider.modalV2";
</style>
